// src/hooks/useChildWindow.js
import { useRef, useEffect } from "react";

export function useChildWindow({ width = 500, height = 500 } = {}) {
  const childRef = useRef(null);

  const open = (integration, url) => {
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    let targetUrl = "";

    // switch (integration) {
    //   case "GMAIL":
    //     url =
    //       type === "success"
    //         ? `${window.location.origin}/integrations/gmail/success`
    //         : `${window.location.origin}/integrations/gmail/error`;
    //     break;
    //   case "O365":
    //     // if (type === "callback") url = `${window.location.origin}/integrations/o365/callback`;
    //     if (type === "success")
    //       url = `${window.location.origin}/integrations/o365/success`;
    //     else url = `${window.location.origin}/integrations/o365/error`;
    //     break;
    //   default:
    //     url = window.location.origin + "/";
    // }

    targetUrl = url;

    childRef.current = window.open(
      targetUrl,
      `${integration}-window-${Date.now()}`, // unique name per open
      `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`
    );
  };

  useEffect(() => {
    return () => {
      if (childRef.current && !childRef.current.closed) {
        childRef.current.close();
      }
    };
  }, []);

  return { open };
}
